exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.paySchedule[data-v-7b2fefce]{width:100%;border-collapse:collapse}.paySchedule td[data-v-7b2fefce],.paySchedule th[data-v-7b2fefce]{border:1px solid #ccc;text-align:center}.paySchedule td[data-v-7b2fefce]{line-height:41px}.paySchedule tr.tb-td td[data-v-7b2fefce]{font-weight:700}td.textCenter[data-v-7b2fefce]{text-align:center}td.textRight[data-v-7b2fefce]{text-align:right}td input[data-v-7b2fefce]{width:100%;text-align:center}table.modal-td td[data-v-7b2fefce]{padding-right:4px!important;text-align:justify}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b2fefce","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lending/disbursement/insert_form.vue
// module id = 1571
// module chunks = 3